import { createI18n } from 'vue-i18n';

import { getPreferredLanguage } from './preferredLanguage';

const preferredLanguage = getPreferredLanguage();

const i18n = createI18n({ legacy: false, locale: preferredLanguage });

export const useGlobalI18n = () => i18n;

export function setI18nLanguage(locale: string) {
  i18n.global.locale.value = locale;
}
